module.exports = __webpack_public_path__ + "img/Data_Science2.40ade80e.png";